import React from "react";

const HeroSection = ({
  title,
  subTitle,
  backgroundColorClass,
  linkPath,
  enContent,
  jpContent,
  questionLinkText,
  questionLinkJpText,
}) => {
  return (
    <div className="container main-section hero-section">
      <div className="responsive-main-section">
        <div className={`title-section ${backgroundColorClass}`}>
          <a href={linkPath} className="title-link">
            <div className="title font-amaticsc-bold">{title}</div>
            <div className="sub-title font-zenkurenaido">{subTitle}</div>
          </a>
        </div>
        <div className="content-section">
          <div className="en-content font-outfit-bold">
            {enContent}
            {questionLinkText && (
              <>
                <br />
                <br />
                {questionLinkText.before}{" "}
                <a href={questionLinkText.path} className="en-question-link">
                  {questionLinkText.linkText}
                </a>
                {questionLinkText.after}
              </>
            )}
          </div>
          <div className="jp-content font-kleeone">
            {jpContent}
            {questionLinkJpText && (
              <>
                <br />
                <br />
                {questionLinkJpText.before}{" "}
                <a href={questionLinkJpText.path} className="jp-question-link">
                  {questionLinkJpText.linkText}
                </a>
                {questionLinkJpText.after}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;